import { createSlice } from "@reduxjs/toolkit";
import { getAxios, postAxios } from "./axiosActions";

export const initialState = {
   loading: false,
   hasErrors: false,
   gptUsage: [],
   apiKey: localStorage.getItem('openAIAPIKey') ?? 'IR',
   input:{}
};

const logSlice = createSlice({
   name: 'log',
   initialState,
   reducers: {
      getGPTUsage: state => {
         state.loading = true;
      },
      getGPTUsageSuccess: (state, { payload }) => {
         state.gptUsage = payload;
         state.loading = false;
         state.hasErrors = false;
      },
      setInput:(state,{payload})=>{
         state.input=payload;
      },
      getGPTUsageFailure: state => {
         state.loading = false;
         state.hasErrors = true;
      },
     setAPIKey: (state, { payload }) => {
         localStorage.setItem('openAIAPIKey', payload)
         state.apiKey = payload;
      },
   },
});

export const { getGPTUsage, getGPTUsageSuccess, getGPTUsageFailure, setAPIKey,setInput } = logSlice.actions;
export const logSelector = state => state.log;
export default logSlice.reducer;
export function fetchGPTUsageData(companyId, userId, input) {
   
   return async dispatch => {
      dispatch(getGPTUsage());
      try {
         const params = { ...input, isHideCallTime: true };
         const data = await postAxios('api/Logs/GetLogs?companyId='+companyId + (userId ? ('&userId=' + userId) : '') , { params: input ? input: {} }, true);
         dispatch(getGPTUsageSuccess(data));
         if(input){
            dispatch(setInput(input))
         }
      } catch (error) {
         dispatch(getGPTUsageFailure());
      }
   };
}

